const loginEvent = {
  CHECK_ACCOUNT: 'CHECK_ACCOUNT',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  REGISTER_ACCOUNT: 'REGISTER_ACCOUNT'
};

export default loginEvent;